<app-side-color-card color="primary-1">
  <div class="holder" content>
    <div class="title-container">
      <h3 class="title">DADOS DO ARMAZÉM</h3>
      <button class="minimize-btn" (click)="toggleMinimize()" [title]="isMinimized ? 'Maximizar' : 'Minimizar'">
        <span *ngIf="!isMinimized">−</span>
        <span *ngIf="isMinimized">+</span>
      </button>
    </div>

    <div class="widget" *ngIf="!isMinimized">
      <div class="canvas-clipper">
     
          <app-doughnut-chart
            [datasets]="datasets" 
            [labels]="chartLabels"
            [showUsage]="true"
            [usage]="usage"
            [chartSize]="window.innerWidth <= 1919 ? 150 : 200">
          </app-doughnut-chart>
      </div>

      <div class="text">
        <h5>Ocupação do Armazém</h5>
        <p>{{total | number:'1.0-0':'pt-BR'}} células totais</p>
        <span>{{now}}</span>
      </div>
    </div>

    <app-common-list [list]="occupationList" *ngIf="!isMinimized"></app-common-list>
  </div>



</app-side-color-card>
